// Progress bar tracking for loading stages

import { t } from '@/i18n'
import { progressBar, progressText } from './elements'

// Stage-based progress mapping (status key → percentage)
export const PROGRESS_STAGES: Array<{ key: string; progress: number }> = [
  { key: 'status.loading', progress: 0 },
  { key: 'status.initializingViewer', progress: 5 },
  { key: 'status.loadingGardens', progress: 10 },
  { key: 'status.loadingGarden', progress: 15 },
  { key: 'status.loadingCategories', progress: 25 },
  { key: 'status.loadingAssets', progress: 35 },
  { key: 'status.preloadingModels', progress: 40 },
  { key: 'status.renderingScheme', progress: 45 },
  { key: 'status.renderingGround', progress: 55 },
  { key: 'status.renderingBuildings', progress: 70 },
  { key: 'status.renderingPlants', progress: 85 },
  { key: 'status.gardenLoaded', progress: 100 }
]

// Build lookup map from translated strings to progress values
function buildProgressLookup(): Map<string, number> {
  const lookup = new Map<string, number>()
  for (const stage of PROGRESS_STAGES) {
    lookup.set(t(stage.key), stage.progress)
  }
  return lookup
}

let progressLookup: Map<string, number> | null = null

function getProgressForStatus(statusText: string): number | undefined {
  // Build lookup lazily (after i18n is initialized)
  if (!progressLookup) {
    progressLookup = buildProgressLookup()
  }
  return progressLookup.get(statusText)
}

/**
 * Reset progress lookup (call after locale change)
 */
export function resetProgressLookup(): void {
  progressLookup = null
}

/**
 * Update progress bar based on status text
 */
export function updateProgress(statusText: string): void {
  const progress = getProgressForStatus(statusText)
  if (progress !== undefined) {
    progressBar.style.width = `${progress}%`
    progressText.textContent = `${progress}%`
  }
  // Unknown status: keep previous progress (don't update)
}
